import jsonExport from "jsonexport/dist";
import { downloadCSV } from "react-admin";
import { DataProvider, getListParamsFromHash } from "./helpers/exporterUtils";

export const userExporter = async (
  _records: any,
  _fetchRelatedRecords: any,
  dataProvider: DataProvider,
  resource: string
) => {
  const { sort, filter } = getListParamsFromHash({
    sortField: "UserCreateDate",
    sortOrder: "DESC",
  });

  const allUsersResponse = await dataProvider.getList(resource, {
    pagination: { page: 1, perPage: 10000 },
    sort,
    filter,
  });

  flatFormatExport(allUsersResponse.data, null, null, resource);
};

const BASE_EXPORT_FIELDS = [
  // --- Human-readable first ---
  "family_name",
  "given_name",
  "name",
  "email",
  "email_verified",

  // --- Business info ---
  "custom:business_name",
  "custom:cell_phone",
  "custom:office_phone",
  "custom:preferred_contact",
  "custom:member_directory",
  "custom:social_media_contact",

  // --- Account / legal ---
  "custom:terms",
  "UserStatus",
  "Enabled",

  // --- System fields last ---
  "Username",
  "sub",
  "id",
  "UserCreateDate",
  "UserLastModifiedDate",
];

const buildBaseRow = (user: any) =>
  Object.fromEntries(BASE_EXPORT_FIELDS.map((key) => [key, user[key] ?? ""]));

export const flatFormatExport = (
  records: any[],
  _f: any,
  _d: any,
  resource: string
) => {
  const rows = records.map((user) => {
    const row: any = buildBaseRow(user);

    // Merge Attributes array
    if (Array.isArray(user.Attributes)) {
      user.Attributes.forEach((attr: any) => {
        if (attr?.Name && !(attr.Name in row)) {
          row[attr.Name] = attr.Value ?? "";
        }
      });
    }

    return row;
  });

  // Append dynamic attribute headers AFTER base fields
  const dynamicHeaders = Array.from(
    new Set(
      rows.flatMap((r) =>
        Object.keys(r).filter((k) => !BASE_EXPORT_FIELDS.includes(k))
      )
    )
  );

  const headers = [...BASE_EXPORT_FIELDS, ...dynamicHeaders];

  const fileName = resource.trim().replace(/(\.csv)+$/i, "");
  jsonExport(rows, { headers, rowDelimiter: "," }, (err: any, csv: string) => {
    if (err) console.error(err);
    else downloadCSV(csv, fileName);
  });
};